import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Copied2Icon, Tooltip } from '@blade/ui-kit'

import { useClipboard } from '../../hooks/use-clipboard'
import { Copy2Icon } from '../icons'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  size?: number
  value: string
  snackbarText?: string
  tooltip?: React.ReactNode
  withTooltip?: boolean
  fullWidth?: boolean
} & ClassNameProps

// TODO: move to buttons
export const CopyButton: React.FC<Props> = ({
  className,
  value,
  size = 16,
  snackbarText,
  tooltip,
  fullWidth = false,
  withTooltip = false,
}) => {
  const { t } = useTranslation()
  const { copyToClipboard } = useClipboard()
  const [isCopied, setCopied] = useState(false)

  const handleCopy: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.stopPropagation()
    e.preventDefault()

    const isCopied = await copyToClipboard(value, {
      showSnackbar: true,
      snackbarText: snackbarText ?? t('common.copied-to-clipboard'),
    })

    if (isCopied) {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  const Icon = isCopied ? Copied2Icon : Copy2Icon

  const renderIcon = () => {
    const iconEl = <Icon size={size} />
    if (withTooltip) {
      return (
        <Tooltip content={tooltip ?? t('common.copy-to-clipboard')}>
          {iconEl}
        </Tooltip>
      )
    }
    return iconEl
  }

  return (
    <Root
      type="button"
      onClick={handleCopy}
      className={className}
      $fullWidth={fullWidth}
    >
      {renderIcon()}
    </Root>
  )
}

const Root = styled.button<{ $fullWidth: boolean }>`
  all: unset;
  pointer-events: auto;
  cursor: pointer;
  width: ${(x) => (x.$fullWidth ? '100%' : 'auto')};

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  overflow: hidden;
  gap: 2px;
`
